import { jsx } from '@emotion/react';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { Fragment } from 'react';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
import { getProfessionalPlanData } from './utils';
export const shouldRender = (data) => {
    const { currentAccount } = data;
    const { isTrialing, trialEndDate } = currentAccount;
    return (!isTrialing &&
        !!trialEndDate &&
        currentAccount.plan.amount === 0 &&
        daysFromNow(trialEndDate) <= 14);
};
export const Component = function ProfessionalTrialEnded(props) {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data, currency } = props;
    const { professionalUpgradeUrl, professionalPlanAmount } = getProfessionalPlanData(data.possiblePlans);
    const nextPlanAmount = professionalPlanAmount;
    const upgradeUrl = professionalUpgradeUrl;
    const pricingText = nextPlanAmount > 0 && (jsx("span", null,
        "for as low as ",
        jsx(Price, { currency: currency }, nextPlanAmount),
        "/month"));
    const onUpgrade = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'professional_trial_ended_banner_cta_clicked',
            interaction_goal: 'upgrade_plan',
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    return (jsx(Alert, { variant: props.variant, title: "Your Professional trial has ended", status: "info" },
        jsx(Fragment, null,
            jsx(Link, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "Upgrade"),
            "\u00A0",
            pricingText,
            " to keep using multi-step Zaps, filters, premium apps, and more")));
};
//# sourceMappingURL=ProfessionalTrialEnded.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
